import ATCField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ATCField";
import IncidentsField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/IncidentsField";
import NumberOfPackagesHandledField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/NumberOfPackagesHandledField";
import ResourceField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/ResourceField";
import SparesField from "@features/vessel-call/vessel-call-status/PortServices/flow/extra-fields/SparesField";
import type { ChangeStatusDrawerInfo } from "@features/vessel-call/vessel-call-status/PortServices/hoc/withDrawers";

interface ExtraFieldProps {
  serviceDetails: ChangeStatusDrawerInfo;
}

const extraFieldsMap = {
  atc: (props: ExtraFieldProps) => <ATCField {...props} />,
  numberOfPackagesHandled: (props: ExtraFieldProps) => <NumberOfPackagesHandledField {...props} />,
  spares: () => <SparesField />,
  incidents: () => <IncidentsField />,
  resources: (props: ExtraFieldProps) => <ResourceField {...props} />,
};

const closedFieldLayoutClassNames: Partial<Record<keyof typeof extraFieldsMap, string>> = {
  numberOfPackagesHandled: "col-start-1",
  incidents: "col-span-2",
  resources: "col-span-2",
};

type ShipChandlingLifeboatsCloseFieldsProps = {
  currentFlowStep: any;
  selectedStatus: string;
} & ExtraFieldProps;

const ShipChandlingLifeboatsCloseFields = ({
  currentFlowStep,
  selectedStatus,
  ...restProps
}: ShipChandlingLifeboatsCloseFieldsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4 md:col-start-1 md:col-end-3">
      {currentFlowStep?.statusesList?.[selectedStatus]?.extraFields?.length
        ? currentFlowStep.statusesList[selectedStatus].extraFields.map(
            (field: keyof typeof extraFieldsMap) => {
              const FieldComponent = extraFieldsMap[field];
              const fieldLayoutClassName = closedFieldLayoutClassNames[field] ?? "";

              if (!FieldComponent) return null;

              return (
                <div className={`mt-4 ${fieldLayoutClassName}`.trim()} key={field}>
                  <FieldComponent {...restProps} />
                </div>
              );
            },
          )
        : null}
    </div>
  );
};

export default ShipChandlingLifeboatsCloseFields;
